export class Status {

    constructor(
        public updateTexts: boolean,
        public blockApp?: boolean,
        public maintenance?: boolean,
        public message?: string,
        public messages?: any
    ){}
}